import { Routes } from '@angular/router';
import {
  LoginComponent,
  DefaultComponent,
  PageErrorComponent,
  FullscreenComponent,
  PageUnauthorizedComponent,
  PageNotFoundComponent,
} from '@era/core';
import { PairPage, PairConfirmPage } from '../pages/pair';
import { GroupResolver, UserResolver } from '@era/security';
import { AuthorizationGuard } from '../auth.guard';
import { FeatureGuard } from '../feature.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: DefaultComponent,
    pathMatch: 'full',
  },
  {
    path: 'locations',
    component: DefaultComponent,
    loadChildren: () => import('./locations-routing.module').then((m) => m.LocationsRoutingModule),
    canMatch: [FeatureGuard, AuthorizationGuard],
    resolve: [GroupResolver, UserResolver],
  },
  {
    path: 'security',
    component: DefaultComponent,
    loadChildren: () => import('./security-routing.module').then((m) => m.SecurityRoutingModule),
    canMatch: [FeatureGuard, AuthorizationGuard],
    resolve: [GroupResolver, UserResolver],
  },
  {
    path: 'settings',
    component: DefaultComponent,
    loadChildren: () => import('./settings-routing.module').then((m) => m.SettingsRoutingModule),
    canMatch: [FeatureGuard, AuthorizationGuard],
  },
  {
    path: 'devices',
    component: DefaultComponent,
    loadChildren: () => import('./devices-routing.module').then((m) => m.DevicesRoutingModule),
    canMatch: [FeatureGuard, AuthorizationGuard],
  },
  {
    path: 'apps',
    component: DefaultComponent,
    loadChildren: () => import('./apps-routing.module').then((m) => m.AppsRoutingModule),
    canMatch: [FeatureGuard, AuthorizationGuard],
  },
  {
    path: 'rollout',
    component: DefaultComponent,
    loadChildren: () => import('./rollout-routing.module').then((m) => m.RolloutRoutingModule),
    canMatch: [FeatureGuard, AuthorizationGuard],
  },
  {
    path: 'virtual-room',
    component: DefaultComponent,
    loadChildren: () => import('./inroom-routing.module').then((m) => m.InRoomRoutingModule),
    canMatch: [FeatureGuard, AuthorizationGuard],
  },
  {
    path: 'management',
    component: DefaultComponent,
    loadChildren: () => import('./management-routing.module').then((m) => m.ManagementRoutingModule),
    canMatch: [FeatureGuard, AuthorizationGuard],
  },
  {
    path: 'mdm',
    component: DefaultComponent,
    loadChildren: () => import('./mdm-routing.module').then((m) => m.MdmRoutingModule),
    canMatch: [FeatureGuard, AuthorizationGuard],
  },
  {
    path: 'pair',
    pathMatch: 'full',
    component: PairPage,
  },
  {
    path: 'pair/:pairingCode',
    pathMatch: 'full',
    component: PairConfirmPage,
  },
  { path: 'error', component: PageErrorComponent },
  {
    path: '',
    component: FullscreenComponent,
    pathMatch: 'full',
    children: [
      { path: 'unauthorized', component: PageUnauthorizedComponent },
      { path: 'error', component: PageErrorComponent },
      { path: '**', component: PageNotFoundComponent },
    ],
  },
  {
    path: '**', // Fallback route: Shows DefaultComponent if no route was matched
    component: DefaultComponent,
    pathMatch: 'full',
  },
];
